export function dateNow(): Date {
  return new Date();
}

export function getTime(): number {
  return dateNow().getTime();
}

export function timeNow(): string {
  return dateNow().toLocaleTimeString(undefined, {
    hour12: false,
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    fractionalSecondDigits: 3,
  });
}

export function now(): number {
  return Date.now();
}
